import snakecaseKeys from 'snakecase-keys';
import { ApiService } from '../../../ApiService';
import { JobRequisitionReason } from '../../../../entities/v1/applicant_tracking/JobRequisitionReason';
import { JobRequisitionReasonList } from '../../../../entities/v1/applicant_tracking/JobRequisitionReasonList';

export class JobRequisitionReasonService {
  public static create(name: string): Promise<JobRequisitionReason> {
    return ApiService.post<JobRequisitionReason>(
      '/api/v1/applicant_tracking/job_requisition_reasons',
      snakecaseKeys({ name }),
    );
  }

  public static batchCreate(names: string[]): Promise<void> {
    return ApiService.post<void>(
      '/api/v1/applicant_tracking/job_requisition_reasons/batch_create',
      snakecaseKeys({ names }),
    );
  }

  public static update(
    id: number,
    name: string,
  ): Promise<JobRequisitionReason> {
    return ApiService.put<JobRequisitionReason>(
      `/api/v1/applicant_tracking/job_requisition_reasons/${id}`,
      snakecaseKeys({ name }),
    );
  }

  public static list(
    includeReasonId?: number,
  ): Promise<JobRequisitionReasonList> {
    return ApiService.get<JobRequisitionReasonList>(
      '/api/v1/applicant_tracking/job_requisition_reasons',
      snakecaseKeys({ includeReasonId }),
    );
  }

  public static delete(id: number): Promise<void> {
    return ApiService.delete<void>(
      `/api/v1/applicant_tracking/job_requisition_reasons/${id}`,
    );
  }
}
